module.exports = __webpack_public_path__ + "static/assets/7e9c5f0123f375a22da59a546fe79062.svg";